window['serviceDiscoveryPrefix']='/api/v1/mfe'